import React from "react";
import { UmbracoProvider } from "components/Umbraco/UmbracoContext";
import  SectorList from "./SectorList";

export default function Sectors(props) {
 
  return (
    <UmbracoProvider umbracoUrl="/api/home/GetPage/SectorType/SectorTypePage" noSpiner="true">
        <SectorList {...props} />
    </UmbracoProvider>
  );
}
